import { useEffect, useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { MriButton, cn } from '@mriqbox/ui-kit'

export interface CopyButtonProps {
    value: string
    label: string
    /** Icone + texto (default) ou so o icone. */
    iconOnly?: boolean
    className?: string
    variant?: 'default' | 'outline' | 'ghost' | 'secondary'
}

/** Botao de copiar com confirmacao visual de 2s (o kit nao da feedback). */
export function CopyButton({ value, label, iconOnly, className, variant = 'outline' }: CopyButtonProps) {
    const [copied, setCopied] = useState(false)

    useEffect(() => {
        if (!copied) return
        const timer = setTimeout(() => setCopied(false), 2000)
        return () => clearTimeout(timer)
    }, [copied])

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(value)
            setCopied(true)
        } catch {
            // Sem permissao de clipboard (http sem localhost): o codigo segue na tela pra copiar na mao.
        }
    }

    const Icon = copied ? Check : Copy

    return (
        <MriButton
            type="button"
            variant={variant}
            size={iconOnly ? 'icon' : 'sm'}
            onClick={copy}
            title={label}
            aria-label={label}
            className={cn(iconOnly && 'h-8 w-8 p-0', className)}
        >
            <Icon className={cn('h-4 w-4', !iconOnly && 'mr-2', copied && 'text-primary')} />
            {!iconOnly && (copied ? 'Copiado' : label)}
        </MriButton>
    )
}
